<template>
  <div class="newRealTask">
    <newRealyObjectHeader></newRealyObjectHeader>
    <router-view></router-view>
  </div>
</template>

<script>
import newRealyObjectHeader from "./components/newRealyObjectHeader";

export default {
  data() {
    return {
      cut_result: 1,
      marketProjectReview: [],
      classCompany: [],
      params: {},
    };
  }, 
  created() {},
  methods: {},

  components: {
    newRealyObjectHeader,
  },
};
</script>
<style lang="scss">
.newRealTask {
  width: 100%;
  height: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/newRealTask/index.vue